/**
 * Replacement utility for jquery.timeago.js
 * Uses moment.js instead and gets the datetime from the datetime/title
 * attribute and inserts the result into the element.
 */

import moment from "moment";

export const timeAgo = (datetime?: string | null): string => {
    return moment(datetime).fromNow();
};
